(function(){
    angular
        .module('maApp.view.pages')
        .controller('CatchAllController', CatchAllController);

    CatchAllController.$inject = ['$scope'];

    function CatchAllController($scope) {

        var vm = this;

        $scope.$on('appinitialized', main);

        function emitControllerLoaded() {
            $scope.$emit('loaded', true);
        }

        function main(){
            emitControllerLoaded(); //tell the rootScope that this controller is finished loading
        }

    }
})();